import Splide from '@splidejs/splide';
import '@splidejs/splide/css'; // Or your preferred theme
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.image-gallery-section').forEach((section) => {
        const igSlider = section.querySelector('.ig-slider');

        new Splide(igSlider, {
            type: 'loop',
            drag: false,
            gap: '32px',
            arrows: false,
            pagination: false,
            autoWidth: true,
            autoScroll: {
                speed: .7,
                pauseOnHover: false,
            },
            clones: 12,
            extensions: { AutoScroll }, // register the extension
        }).mount({ AutoScroll }); // mount the extension
    });
});
